import { useEffect, useState, useCallback } from "react";
import usePagination from "../usePagination";
import { fetchContentReport } from "../../service/AdminService/courseService";

const useContentReport = (courseId) => {
  const {
    currentPage,
    pageSize,
    setTotal,
    handlePageChange,
    paginationConfig,
    setCurrentPage,
  } = usePagination();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isContentActive, setIsContentActive] = useState(true);
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchText);
  const [title, setTitle] = useState("");

  const fetchData = useCallback(async () => {
    if (!courseId) return;

    setLoading(true);
    try {
      const params = {
        page: currentPage,
        size: pageSize,
        isContentActive,
        searchText: debouncedSearchText,
      };

      const res = await fetchContentReport(courseId, params);
      

      if (res.success) {
        setData(res.data?.content || []);
        setTotal(res.data?.total || 0);
        setTitle(res?.data?.metaDetails?.name)
      } else {
        setData([]);
        setTotal(0);
      }
    } catch (err) {
      setData([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [courseId, currentPage, pageSize, debouncedSearchText, isContentActive, setTotal]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  const handleSearch = (value) => {
    setSearchText(value);
    setCurrentPage(0);
  };

const handleContentActiveChange = (value) => {
  const isActive = value === "active";
  setIsContentActive(isActive);
  setCurrentPage(0);
};

  return {
    data,
    loading,
    searchText,
    setSearchText,
    handleSearch,
    isContentActive,
    handleContentActiveChange,
    paginationConfig,
    handlePageChange,
    title,
  };
};

export default useContentReport;
